import moment from 'moment';

export type TimeUnitGranularity = 'hour' | 'minute' | 'second';

export type DateTimeLikeValue = Date | moment.Moment | null | undefined;

export interface TimeSlotRangeLike {
  readonly start?: DateTimeLikeValue;
  readonly end?: DateTimeLikeValue;
}

export interface NormalizedTimeSlotRange {
  readonly start?: Date;
  readonly end?: Date;
}

function toDate(value: DateTimeLikeValue): Date | undefined {
  if (!value) {
    return undefined;
  }

  if (moment.isMoment(value)) {
    const momentDate = value.toDate();
    return Number.isNaN(momentDate.getTime()) ? undefined : momentDate;
  }

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return new Date(value.getTime());
  }

  return undefined;
}

export function normalizeDateTimeToUnit(
  value: DateTimeLikeValue,
  unit: TimeUnitGranularity = 'minute',
): Date | undefined {
  const date = toDate(value);

  if (!date) {
    return undefined;
  }

  const normalizedDate = new Date(date.getTime());

  switch (unit) {
    case 'hour':
      normalizedDate.setUTCMinutes(0, 0, 0);
      break;
    case 'minute':
      normalizedDate.setUTCSeconds(0, 0);
      break;
    case 'second':
      normalizedDate.setUTCMilliseconds(0);
      break;
    default:
      break;
  }

  return normalizedDate;
}

export function normalizeTimeSlotRangeToUnit(
  value: TimeSlotRangeLike | undefined,
  unit: TimeUnitGranularity = 'minute',
): NormalizedTimeSlotRange | undefined {
  if (!value) {
    return undefined;
  }

  return {
    start: normalizeDateTimeToUnit(value.start, unit),
    end: normalizeDateTimeToUnit(value.end, unit),
  };
}
